import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { User } from "@tabipla/shared/domain";
import type { MemberType } from "@tabipla/shared";

// Participant represents either a user or a guest
export interface Participant {
  id: string;
  name: string;
  type: MemberType;
  email?: string;
  // Additional user fields (only for users)
  emailVerified?: boolean;
  image?: string | null;
  avatarEmoji?: string | null;
  avatarColor?: string | null;
  createdAt?: Date;
  updatedAt?: Date;
}

// Persisted atoms (saved to localStorage)
export const userAtom = atomWithStorage<User | null>("auth-user", null);
export const participantAtom = atomWithStorage<Participant | null>("auth-participant", null);

// Non-persisted atoms (reset on page refresh)
export const isLoadingAtom = atom(true);

// Flag to track if initial auth check has completed
export const isAuthCheckedAtom = atom(false);

// Derived atoms (computed from other atoms)
// Only consider authenticated if auth check has completed AND participant exists
export const isAuthenticatedAtom = atom((get) => {
  const isAuthChecked = get(isAuthCheckedAtom);
  const participant = get(participantAtom);
  // If auth check hasn't completed yet, don't consider authenticated
  if (!isAuthChecked) return false;
  return participant !== null;
});
